import { isPhoneInLandscape } from '../../../../styles'

export default () =>
  ({
    default: {
      content: {
        flex: '0 1 auto',
        margin: '0 0 0 16px',

        [isPhoneInLandscape]: {
          alignItems: 'stretch',
          flexDirection: 'column',
          margin: '8px 0 8px 0',
          width: '100%',
        },
      },

      buttonsWrapper: {
        flex: '1 0 auto',
      },

      // Primary (left)
      primary: {
        marginInlineEnd: '12px',
      },
    },
  }) as const
